import { billOfMaterialsIdFormat } from "@redotech/redo-fulfillment-id";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { BillOfMaterialsLocation } from "./bill-of-materials-location-types";

export const createBillOfMaterialsLocation = {
  name: "createBillOfMaterialsLocation" as const,
  input: z.object({
    bomId: billOfMaterialsIdFormat.schema,
    locationId: locationIdFormat.schema,
  }),
  output: z.object({ location: BillOfMaterialsLocation }),
};
